import React, { useState, useEffect, KeyboardEventHandler } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { SingleBusinessData, UpdateBusiness } from '../../../store/actions/new/businessAction';
import { CountryDropdown } from 'react-country-region-selector';
import { TagsInput } from 'react-tag-input-component';
import UpdateBusinessInfo from './edit-popup/buisinessInfoPopup';
import Header from '../../../components/default/header';
import UpdateBusinessAddress from './edit-popup/addressPopup';
import UpdateBusinessServices from './edit-popup/businessServices';
import ItemsSelectorPopup from '../../default/popup/itemsSelectorPopup';




const BusinessInfoSettings = () => {

    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();
    const storeData = useSelector((state) => state.businessAllData);
    const { singleBusiness } = storeData || {};
    const dispatch = useDispatch();
    const [openInfoPopup, setInfoPopup] = useState(false);
    const [openAddressPopup, setAddressPopup] = useState(false);
    const [openServicesPopup, setServicesPopup] = useState(false);
    const [openCategoryPopup, setCategoryPopup] = useState(false);
    const handleInfoPopup = () => {
        setInfoPopup(true);
    }
    const handleAddressPopup = () => {
        setAddressPopup(true);
    }
    const handleServicesPopup = () => {
        setServicesPopup(true);
    }
    const handleCategoryPopup = () => {
        setCategoryPopup(true);
    }
    const handleCategorySelect = (item) => {
        setCategoryPopup(false);
        let formData = {
            id: id,
            columns: {
                category: item.id
            }
        }
        dispatch(UpdateBusiness(formData));
    }

    useEffect(() => {
        if (singleBusiness) {

        }
        else {
            dispatch(SingleBusinessData(id));
        }
    }, [id, singleBusiness]);




    return (
        <>
            <div className="settings-list-wrapper">
                <div className="single-settings-info" id='business-info'>
                    <div className="set-info-Header">
                        <h4 className="setting-title">Business info</h4>
                        <button className="edit-btn" onClick={handleInfoPopup}><i className="ri-edit-line"></i> Edit</button>
                    </div>
                    <div className="bsns-setting-content">
                        <div className="bsns-content-repeater">
                            <b>Name:</b>
                            <span>{singleBusiness?.name}</span>
                        </div>
                        <div className="bsns-content-repeater">
                            <b>Tagline:</b>
                            <span>{singleBusiness?.tagLine}</span>
                        </div>
                        <div className="bsns-content-repeater">
                            <b>Website:</b>
                            <span>{singleBusiness?.website}</span>
                        </div>
                    </div>
                </div>
                <div className="single-settings-info" id='category-section'>
                    <div className="set-info-Header">
                        <h4 className="setting-title">Business Category</h4>
                        <button className="edit-btn" onClick={handleCategoryPopup}><i className="ri-edit-line"></i> Edit</button>
                    </div>
                    <div className="bsns-setting-content">
                        <div className="bsns-content-repeater">
                            <b>Name:</b>
                            <span>{singleBusiness?.category?.name}</span>
                        </div>
                    </div>
                </div>
                <div className="single-settings-info" id='service-section'>
                    <div className="set-info-Header">
                        <h4 className="setting-title">Product or Service</h4>
                        <button className="edit-btn" onClick={handleServicesPopup}><i className="ri-edit-line"></i> Edit</button>
                    </div>
                    <div className="bsns-setting-content">
                        <div className="bsns-content-repeater">
                            <ul>
                                {singleBusiness?.services?.data?.length > 0 ? (
                                    singleBusiness.services.data.map((service) => (
                                        <li key={service.id}>
                                            {service.name}
                                        </li>
                                    ))
                                ) : (
                                    <li>No services available</li> // Fallback message
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="single-settings-info" id='address-section'>
                    <div className="set-info-Header">
                        <h4 className="setting-title">Business Address</h4>
                        <button className="edit-btn" onClick={handleAddressPopup}><i className="ri-edit-line"></i> Edit</button>
                    </div>
                    <div className="bsns-setting-content">
                        <div className="bsns-content-repeater">
                            <b>Address:</b>
                            <span>
                                {singleBusiness?.address?.address} <br />
                                {singleBusiness?.address?.city},&nbsp;
                                {singleBusiness?.address?.state}&nbsp;
                                {singleBusiness?.address?.zip_code}&nbsp;
                                {singleBusiness?.address?.country}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <UpdateBusinessInfo openModal={openInfoPopup} setOpen={setInfoPopup} type="business info" singleBusiness={singleBusiness} />
            <UpdateBusinessAddress openModal={openAddressPopup} setOpen={setAddressPopup} type="business info" singleBusiness={singleBusiness} />
            <UpdateBusinessServices openModal={openServicesPopup} setOpen={setServicesPopup} type="Services" singleBusiness={singleBusiness} />
            <ItemsSelectorPopup openModal={openCategoryPopup} setOpen={setCategoryPopup} onItemSelect={handleCategorySelect} type="business" title="Select Category" /> 
        </>
        // <form onSubmit={handleSubmit}>
        //     <div className="settings-list-wrapper">
        //         <div className="single-settings">
        //             <h5 className="setting-title">Update Business</h5>
        //             <div className="setting-content">
        //                 <div className="sng-content-repeater">
        //                     <div className="sng-content">
        //                         <label>Business name</label>
        //                         <input 
        //                             className="sett-form-input" 
        //                             name="name" 
        //                             placeholder="Creative Solution" 
        //                             value={formData.columns.name}
        //                             onChange={handleInputChange}
        //                         />
        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater">
        //                     <div className="sng-content">
        //                         <label>Tag line</label>
        //                         <input 
        //                             className="sett-form-input" 
        //                             name="tagLine" 
        //                             placeholder="e.g. Your innovation"
        //                             value={formData.columns.tagLine}
        //                             onChange={handleInputChange}
        //                         />
        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater"> 
        //                     <div className="sng-content">
        //                         <label>Business Category</label>
        //                         <select 
        //                             className="sett-form-input" 
        //                             name="ProductService"
        //                             value={formData.columns.category?.name}
        //                             onChange={handleInputChange}
        //                         >
        //                             <option value="Development">Development</option>
        //                             <option value="UI">UI</option>
        //                             <option value="Card">Card</option>
        //                             <option value="Identity">Identity</option>
        //                         </select>
        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater"> 
        //                     <div className="sng-content">
        //                         <label>Product or Service</label>

        //                         <TagsInput
        //                             value={selected}
        //                             onChange={setSelected}
        //                             name="productService"
        //                             placeHolder="Add category"
        //                             classNames="sett-form-input"
        //                         />

        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater">
        //                     <div className="sng-content">
        //                         <label>Website</label>
        //                         <input 
        //                             type="text" 
        //                             className="sett-form-input" 
        //                             name="website" 
        //                             placeholder="e.g. https://example.com"
        //                             value={formData.columns.website}
        //                             onChange={handleInputChange}
        //                         />
        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater business-profile">
        //                     <div className="sng-content">
        //                         <h5>Logo</h5>
        //                         <label htmlFor="BusinessLogo">
        //                             <i className="ri-edit-2-line"></i>
        //                             <input 
        //                                 id="BusinessLogo" 
        //                                 type="file" 
        //                                 className="sett-form-input" 
        //                                 name="feature_photo_url"
        //                                 onChange={handleFileChange}
        //                             />
        //                         </label>
        //                     </div>
        //                     <div className="sng-content">
        //                         <h5>Cover</h5>
        //                         <label htmlFor="BusinessCover">
        //                             <i className="ri-edit-2-line"></i>
        //                             <input 
        //                                 id="BusinessCover" 
        //                                 type="file" 
        //                                 className="sett-form-input" 
        //                                 name="BusinessCover"
        //                                 onChange={handleFileChange}
        //                             />
        //                         </label>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="single-settings">
        //             <h5 className="setting-title">Business Address</h5>
        //             <div className="setting-content">
        //                 <div className="sng-content-repeater"> 
        //                     <div className="sng-content">
        //                         <label>Street address</label>
        //                         <input 
        //                             type="text" 
        //                             className="sett-form-input" 
        //                             name="address" 
        //                             placeholder="235 park street, NY"
        //                             value={formData.columns.address?.address}
        //                             onChange={(e)=>{handleInputChange(e, 'address')}}
        //                         />
        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater"> 
        //                     <div className="sng-content">
        //                         <label>City</label>
        //                         <input 
        //                             type="text" 
        //                             className="sett-form-input" 
        //                             name="city" 
        //                             placeholder="e.g. NY"
        //                             value={formData.columns.address?.city}
        //                             onChange={(e)=>{handleInputChange(e, 'address')}}
        //                         />
        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater d-auto"> 
        //                     <div className="sng-content">
        //                         <label>State</label>
        //                         <input 
        //                             type="text" 
        //                             className="sett-form-input" 
        //                             name="state" 
        //                             placeholder="e.g. State"
        //                             value={formData.columns?.address?.state}
        //                             onChange={(e)=>{handleInputChange(e, 'address')}}
        //                         />
        //                     </div>
        //                     <div className="sng-content">
        //                         <label>Zip code</label>
        //                         <input 
        //                             type="text" 
        //                             className="sett-form-input" 
        //                             name="zip_code" 
        //                             placeholder="e.g. 9000"
        //                             value={formData.columns.address?.zip_code}
        //                             onChange={(e)=>{handleInputChange(e, 'address')}}
        //                         />
        //                     </div>
        //                 </div>
        //                 <div className="sng-content-repeater"> 
        //                     <div className="sng-content">
        //                         <label>Country</label>
        //                         <CountryDropdown 
        //                             value={formData.columns.address?.country || 'US'} 
        //                             name="country"
        //                             className="sett-form-input"
        //                             valueType="short"
        //                             onChange={(e)=>{handleInputChange(e, 'address')}} 
        //                             />
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="button-wrapper">
        //             <button type="button" className="btn cancel-btn">Cancel</button>
        //             <button type="submit" className="btn submit-btn bg-primary">
        //                 {isLoading ? 'Updating...' : 'Update'}
        //             </button>
        //         </div>
        //     </div>
        //     <UpdateBusinessInfo openModal={openPopup} setOpen={setPopup} type="business info" singleBusiness={singleBusiness} />
        // </form>
    );
}


export default BusinessInfoSettings;